import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-verified",
  templateUrl: "./med-icon-verified.component.html",
})
export class MedIconVerifiedComponent extends SvgMixinComponent {}
